

import React from 'react';
import { Box, Text } from '../../shared/components';

export default function InlineCard({ headerText, content }) {
  return (
    <Box className="inlineCard">
      <Text
        px={5}
        py={3}
        style={{
          color: '#8798AD',
          fontFamily: 'Rubik',
          fontSize: '13px',
          letterSpacing: '1.21px',
          lineHeight: '15px',
          marginTop: '7px',

        }}
      >
        {headerText}

      </Text>
      <Box p={5} bg="white">
        { content }
      </Box>
    </Box>
  );
}
